<template>
  <div id="detail" class="divHT" style="background:white;">
    <router-link :to="returnUrl" >&#x3c; Revenir à la liste</router-link>
    <div slot="table-busy" class="text-center text-danger my-2" v-if="isBusy">
      <b-spinner class="align-middle"></b-spinner>
      <strong>Chargement ...</strong>
    </div>
    <div class="overflow-auto filers" v-if="!isBusy && (factures.length || rapports.length)">
      <div class="row">
        <div class="col-md-6 p-3">
            <div class="text-center grayBG radius">
                <h2>{{$t("Rapports")}}</h2>
                <ul class="extrait bg-white radius mb-5 mt-5" v-for="(rapport,index) in rapports" :key="index">
                    <li><b-link size="sm" @click="goto(idpage,rapport.url)" class="mr-1" :disabled="can_see_rapport"><i class="font-icon" data-icon="803"></i> {{ rapport.name }}</b-link></li>
                </ul>
            </div>
        </div>
        <div class="col-md-6 p-3">
            <div class="text-center grayBG radius">
                <h2>{{$t("Factures")}}</h2>
                <ul class="extrait bg-white radius mb-5 mt-5" v-for="(facture,index) in factures" :key="index">
                    <li><b-link size="sm" @click="goto(idpage,facture.url)" class="mr-1" :disabled="can_see_facture"><i class="font-icon" data-icon="803"></i> {{ facture.name }}</b-link></li>
                </ul>
            </div>
        </div>
      </div>
    </div>
    <div class="overflow-auto filers" v-if="!isBusy">
        <div class="p-3">
            <h2>{{$t("Récapitulatif de votre commande")}}</h2>
            <div class="extrait grayBG radius mb-5 mt-5" v-for="(recap,index) in recaps" :key="index">
              <h3>{{ $t(recap.libelle) }}</h3>
              <p v-for="(recapVal,recapLib) in recap.liste" :key="recapLib"><b>{{ $t(recapLib) }} : </b> <span v-html="recapVal"></span></p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    data() {
      return {
        isBusy: true,
        idpage:0,
        returnUrl:'',
        factures:[],
        rapports:[],
        recaps:[],
        nodata:'Données insuffisantes',
        can_see_facture:false,
        can_see_rapport:false,
      };
    },
    methods:{
        goto(id,url){
            window.open(this.$apiUrl+"demandes/filerf/"+id+"/"+url+"?auth="+JSON.stringify(this.auth_header()));
        }
    },
    mounted() {
      var p = this;
      p.idpage = p.$route.params.id;
      p.returnUrl = "/"+p.get_first_route();
      axios.get(p.$apiUrl+"demandes/detail/"+p.idpage ,{params : {auth:p.auth_header(),lang:this.$i18n.locale}}).then(response => {
        if(response.data.error=='notlogged'){
          p.logout();
          p.$router.push({ path: '/' });
        }
        if (response.data.datas) {
          p.factures = response.data.datas.factures;
          p.rapports = response.data.datas.rapports;
          p.recaps = response.data.datas.recaps;
          p.can_see_facture = response.data.right.see_facture;
          p.can_see_rapport = response.data.right.see_rapport;
          p.isBusy=false;
        } else {
          p.show_alert("warning","Pas de données disponible");
          p.isBusy=false;
        }
      }).catch(error => {});
    },
  };
</script>